














































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GJgrowEventCreateFormFormat from '../GJgrowEventCreateFormFormat.vue';
import { email, required } from 'vuelidate/lib/validators';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GVTag from '@/components/GVTag.vue';
import moment from 'moment';
import { globalModule } from '@/store/modules/global.module';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';

@Component({
  name: 'GJgrowEventCreateTerm',
  components: { GVTag, GJgrowEventCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    startDate: { required },
    endDate: { required },
  },
})
export default class GJgrowEventCreateTerm extends mixins(GPageBase) {
  @Prop() title: string;
  @Prop() start: Date;
  @Prop() end: Date;
  @Prop({default: null}) requireStartAfterAtTitle: string;
  @Prop({default: null}) requireStartAfterAt: Date;
  @Prop({default: null}) requireStartBeforeAtTitle: string;
  @Prop({default: null}) requireStartBeforeAt: Date;
  @Prop({default: null}) requireEndAfterAt: Date;
  @Prop({default: null}) requireEndBeforeAt: Date;

  isStartTimeChange: boolean = false;
  mounted() {
  }

  get isStartBeforeAt(): boolean {
    return moment(this.startDate) >= moment(this.requireStartBeforeAt);
  }

  get isStartBeforeAtMsg(): string {
    return "開始時間が" + this.requireStartBeforeAtTitle + "より前に設定されています。";
  }

  get startDate(): Date {
    return this.start;
  }

  get endDate(): Date {
    return this.end;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get evalSettingModeEditAndUnderExamination(): boolean {
    return examCreateModule.evalSettingModeEdit && this.evalSettingDetail.isUnderExamination;
  }

  get isStartTimeInvalid(): boolean {
    return this.$v.startDate.$dirty && this.$v.startDate.$invalid;
  }
  get isStartTimeBeforeCurrentTime(): boolean {
    return moment(this.eventParam.startDate) <= moment(new Date()).add(-5, 'm');
  }

  get isDeadlineInvalid(): boolean {
    return this.$v.endDate.$dirty && this.$v.endDate.$invalid;
  }

  get isDeadlineBeforeStartTime(): boolean {
    return !this.$v.startDate.$invalid && !this.$v.endDate.$invalid && moment(this.eventParam.endDate) <= moment(this.eventParam.startDate);
  }

  touchDeadline(): void {
    this.$v.endDate.$touch();
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return (date && moment(date) < moment(startDate).add(-1, 'd')) || moment(new Date(globalModule.selectedSchoolYear + 1, 3, 1)) <= moment(date);
      },
    };
  }

  /**
   * 開始時間変更時
   */
  handleStartTimeChange(value: string) {
    this.isStartTimeChange = true;
    this.start = value === '' ? null : moment(value).toDate();
    this.$v.startDate.$touch();
  }

  /**
   * 終了時間変更時
   */
  handleDeadlineChange(value: string) {
    this.end = value === '' ? null : moment(value).toDate();
    this.touchDeadline();
  }

  touch() {
    this.$v.$touch();
  }

  isValid(): boolean {
    if (this.evalSettingModeEditAndUnderExamination) {
      // 受検開始後の編集の場合、開始日時が現在時刻より前かどうかの判定はしない
      return !this.isStartTimeInvalid && !this.isDeadlineInvalid && !this.isDeadlineBeforeStartTime;
    } else {
      return !this.isStartTimeInvalid && !this.isStartTimeBeforeCurrentTime && !this.isDeadlineInvalid && !this.isDeadlineBeforeStartTime;
    }
  }
}
